<template>
  <div class="warehouse">
    <page-title v-if="page" :page="page" />

    <router-view></router-view>
    <faq-bar v-if="isAuthenticated" />
    <be-customer-card-horizontal card="registrationHome" />
    <newsletter-horizontal />
  </div>
</template>

<script>
import page from "~/mixins/page.js";
import BeCustomerCardHorizontal from "@/components/cards/BeCustomerCardHorizontal.vue";
import NewsletterHorizontal from "@/components/cards/NewsletterHorizontal.vue";
import FaqBar from "@/components/registration/FaqBar.vue";
import { mapGetters } from "vuex";
import PageTitle from "@/components/wordpress/PageTitle.vue";

export default {
  name: "Profile",
  components: {
    PageTitle,
    BeCustomerCardHorizontal,
    NewsletterHorizontal,
    FaqBar
  },
  mixins: [page],
  computed: {
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    })
  },
  async mounted() {
    await this.fetchPage("punti-vendita");
  }
};
</script>
